import packageUserType from "@/constants/package-user-type/index.js";
import currentStatuses from "@/constants/statuses/index";


function checkStatus({ isOnBehalfOf, recipientOrgId, onBehalfOrgId, savedPayload, elementSchema }) {

	let isAttachmentsAdded = false
	let isAttachmentsRequired = false
	if (elementSchema?.required?.includes("attachments")) {
		isAttachmentsRequired = true
		isAttachmentsAdded = savedPayload?.[0]?.attachments?.length > 0
	}

	if (isOnBehalfOf && recipientOrgId?.length > 0 && onBehalfOrgId?.length > 0 && savedPayload?.length > 0 && (isAttachmentsRequired === isAttachmentsAdded)) {
		return currentStatuses.complete
	}

	if (!isOnBehalfOf && recipientOrgId?.length > 0 && savedPayload?.length > 0 && (isAttachmentsRequired === isAttachmentsAdded)) {
		return currentStatuses.complete
	}


	if (recipientOrgId?.length > 0 || onBehalfOrgId?.length > 0 || savedPayload?.length > 0) {
		return currentStatuses.in_progress
	}


	return currentStatuses.not_started
}

function checkUserType(userOrgId, contributorOrgId, consumerOrgId, providerOrgId) {

	if (userOrgId === contributorOrgId?.id) {
		return packageUserType.contributor
	}

	if (userOrgId === consumerOrgId?.id) {
		return packageUserType.consumer
	}

	if (userOrgId === providerOrgId?.id) {
		return packageUserType.provider
	}

	return ""
}
export { checkStatus, checkUserType };
